module.exports = __webpack_public_path__ + "img/glyphs-dark.1d8a90d2.png";